module.exports = __webpack_public_path__ + "img/avatar.fbbd4153.jpg";